import axios from 'axios';
import api from '../helper/api';

/**
 * Initiate a withdrawal transaction
 * @param {Object} payload - { amount, mode }
 * @returns {Promise<{transaction_id: string, status: string, ...}>}
 */
export const initiateWithdrawal = async (payload) => {
  try {
    const response =  await api.post(`withdrawal`, payload);
              return response.data;
  } catch (error) {
    console.error('Withdrawal API error:', error);
    throw error;
  }
};
